import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { Button, Icon } from '@sbt-web/ui';
export default function BackButton() {
  const $ = _c(5);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    t0 = () => window.history.length > 2 ? router.back() : window.location.assign(process.env.NEXT_PUBLIC_ENV_BASE_URL);
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClick = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon name="ArrowLeft" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== handleClick) {
    t2 = <Button size="small" design="outline" icon={t1} onClick={handleClick}>Indietro</Button>;
    $[3] = handleClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}